'use client';

// Terminal track.ts com efeito de digitacao em loop (typewriter colorido).
// Codigo ficticio = evento completo que disparamos pra Meta. Pausa fora da viewport
// e respeita prefers-reduced-motion (mostra o codigo completo, sem digitar).

import { useEffect, useRef, useState } from 'react';

// [texto, cor]. cor '' = base.
const TOKENS: [string, string][] = [
  ['POST', '#79c0ff'],
  [' /v1/track\n{\n  ', ''],
  ['"event"', '#a884ff'],
  [': ', ''],
  ['"Purchase"', '#7ee787'],
  [',\n  ', ''],
  ['"value"', '#a884ff'],
  [': ', ''],
  ['497.00', '#ffb86b'],
  [',\n  ', ''],
  ['"currency"', '#a884ff'],
  [': ', ''],
  ['"BRL"', '#7ee787'],
  [',\n  ', ''],
  ['"email"', '#a884ff'],
  [': ', ''],
  ['"sha256:9f86d0…"', '#7ee787'],
  [',\n  ', ''],
  ['"phone"', '#a884ff'],
  [': ', ''],
  ['"sha256:3a7bd3…"', '#7ee787'],
  [',\n  ', ''],
  ['"fbc"', '#a884ff'],
  [': ', ''],
  ['"fb.1.1718…"', '#7ee787'],
  [',\n  ', ''],
  ['"fbp"', '#a884ff'],
  [': ', ''],
  ['"fb.1.1718…"', '#7ee787'],
  [',\n  ', ''],
  ['"ip"', '#a884ff'],
  [': ', ''],
  ['"187.xx.xx.xx"', '#7ee787'],
  [',\n  ', ''],
  ['"user_agent"', '#a884ff'],
  [': ', ''],
  ['"Mozilla/5.0…"', '#7ee787'],
  [',\n  ', ''],
  ['"utm_source"', '#a884ff'],
  [': ', ''],
  ['"facebook"', '#7ee787'],
  [',\n  ', ''],
  ['"utm_campaign"', '#a884ff'],
  [': ', ''],
  ['"escala-q2"', '#7ee787'],
  [',\n  ', ''],
  ['"order_bump"', '#a884ff'],
  [': ', ''],
  ['true', '#79c0ff'],
  [',\n  ', ''],
  ['"server_side"', '#a884ff'],
  [': ', ''],
  ['true', '#79c0ff'],
  ['\n}\n', ''],
  ['→ 200', '#79c0ff'],
  [' ', ''],
  ['enviado à Meta ✓  EMQ 9.2', '#7ee787'],
];

interface Char {
  ch: string;
  color: string;
}
const FLAT: Char[] = TOKENS.flatMap(([txt, color]) => [...txt].map((ch) => ({ ch, color })));

function esc(c: string): string {
  return c === '<' ? '&lt;' : c === '>' ? '&gt;' : c === '&' ? '&amp;' : c;
}

function toHtml(n: number): string {
  let html = '';
  let i = 0;
  while (i < n) {
    const color = FLAT[i]?.color ?? '';
    let chunk = '';
    while (i < n && FLAT[i]?.color === color) {
      chunk += esc(FLAT[i]!.ch);
      i += 1;
    }
    html += color ? `<span style="color:${color}">${chunk}</span>` : chunk;
  }
  return html;
}

const FULL_HTML = toHtml(FLAT.length);

export function TrackTerminal() {
  const ref = useRef<HTMLSpanElement | null>(null);
  const [reduced, setReduced] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      setReduced(true);
      el.innerHTML = FULL_HTML;
      return;
    }

    let n = 0;
    let phase: 'typing' | 'hold' | 'reset' = 'typing';
    let timer: ReturnType<typeof setTimeout>;
    let inView = true;
    const io = new IntersectionObserver((e) => {
      inView = e[0]?.isIntersecting ?? true;
    });
    io.observe(el);

    const tick = (): void => {
      if (!inView) {
        timer = setTimeout(tick, 300);
        return;
      }
      if (phase === 'typing') {
        n += 1;
        el.innerHTML = toHtml(n);
        if (n >= FLAT.length) {
          phase = 'hold';
          timer = setTimeout(tick, 2400);
          return;
        }
        timer = setTimeout(tick, 16 + Math.random() * 30);
      } else {
        n = 0;
        el.innerHTML = '';
        phase = 'typing';
        timer = setTimeout(tick, 400);
      }
    };
    timer = setTimeout(tick, 500);
    return () => {
      clearTimeout(timer);
      io.disconnect();
    };
  }, []);

  return (
    <div className="overflow-hidden rounded-2xl border border-[rgba(222,219,246,0.1)] bg-[#0c0a14] shadow-[0_24px_60px_-18px_rgba(0,0,0,0.7)]">
      <div className="flex h-9 items-center gap-[7px] border-b border-[rgba(222,219,246,0.06)] bg-white/[0.02] px-3.5">
        <i className="h-[11px] w-[11px] rounded-full bg-[#ff5f57]" />
        <i className="h-[11px] w-[11px] rounded-full bg-[#febc2e]" />
        <i className="h-[11px] w-[11px] rounded-full bg-[#28c840]" />
        <span className="ml-2 font-mono text-[11px] text-[#6E6B86]">track.ts</span>
      </div>
      <div className="min-h-[400px] px-5 py-4 font-mono text-[12.5px] leading-[1.7] break-words whitespace-pre-wrap text-[#8B88A8] md:min-h-[430px] md:text-[13px]">
        <span ref={ref} />
        {!reduced && (
          <span className="ml-px inline-block h-[15px] w-2 translate-y-[2px] [animation:trakd-blink_1s_steps(2)_infinite] bg-[#a884ff]" />
        )}
      </div>
    </div>
  );
}

export default TrackTerminal;
